export { default as ActivityIcon } from '../assets/Activity.svg';
export { default as AddIcon } from '../assets/Add.svg';
export { default as AlertIcon } from '../assets/Alert.svg';
export { default as AppleLogoIcon } from '../assets/AppleLogo.svg';
export { default as ArchiveIcon } from '../assets/Archive.svg';
export { default as BackwardIcon } from '../assets/Backward.svg';
export { default as BellIcon } from '../assets/Bell.svg';
export { default as BoldIcon } from '../assets/Bold.svg';
export { default as CalendarIcon } from '../assets/Calendar.svg';
export { default as CashIcon } from '../assets/Cash.svg';
export { default as CheckmarkIcon } from '../assets/Checkmark.svg';
export { default as ChessQueenIcon } from '../assets/ChessQueen.svg';
export { default as ChevronDownIcon } from '../assets/ChevronDown.svg';
export { default as ChevronLeftIcon } from '../assets/ChevronLeft.svg';
export { default as ChevronRightIcon } from '../assets/ChevronRight.svg';
export { default as CircleCheckmarkIcon } from '../assets/CircleCheckmark.svg';
export { default as CircleRemoveIcon } from '../assets/CircleRemove.svg';
export { default as CircleUserIcon } from '../assets/CircleUser.svg';
export { default as CityIcon } from '../assets/City.svg';
export { default as CloseIcon } from '../assets/Close.svg';
export { default as ComposeIcon } from '../assets/Compose.svg';
export { default as ComposeTweetIcon } from '../assets/ComposeTweet.svg';
export { default as ContrastIcon } from '../assets/Contrast.svg';
export { default as ConversationIcon } from '../assets/Conversation.svg';
export { default as CopyIcon } from '../assets/Copy.svg';
export { default as DashIcon } from '../assets/Dash.svg';
export { default as DashboardIcon } from '../assets/Dashboard.svg';
export { default as DeleteIcon } from '../assets/Delete.svg';
export { default as DialogueIcon } from '../assets/Dialogue.svg';
export { default as DocumentIcon } from '../assets/Document.svg';
export { default as DownloadIcon } from '../assets/Download.svg';
export { default as DraftsIcon } from '../assets/Drafts.svg';
export { default as EmojiIcon } from '../assets/Emoji.svg';
export { default as FolderIcon } from '../assets/Folder.svg';
export { default as FriendsFeminineMasculineIcon } from '../assets/FriendsFeminineMasculine.svg';
export { default as FriendsIcon } from '../assets/Friends.svg';
export { default as FullScreenIcon } from '../assets/FullScreen.svg';
export { default as GearIcon } from '../assets/Gear.svg';
export { default as GiftIcon } from '../assets/Gift.svg';
export { default as GridIcon } from '../assets/Grid.svg';
export { default as GroupsIcon } from '../assets/Groups.svg';
export { default as GoogleLogoIcon } from '../assets/GoogleLogo.svg';
export { default as HammerIcon } from '../assets/Hammer.svg';
export { default as HeartRateIcon } from '../assets/HeartRate.svg';
export { default as HelpIcon } from '../assets/Help.svg';
export { default as HistoryIcon } from '../assets/History.svg';
export { default as HomeIcon } from '../assets/Home.svg';
export { default as ItalicIcon } from '../assets/Italic.svg';
export { default as JunkIcon } from '../assets/Junk.svg';
export { default as LibraryIcon } from '../assets/Library.svg';
export { default as DirectionsIcon } from '../assets/Directions.svg';
export { default as LinkIcon } from '../assets/Link.svg';
export { default as ListIcon } from '../assets/List.svg';
export { default as LockIcon } from '../assets/Lock.svg';
export { default as LogOutIcon } from '../assets/LogOut.svg';
export { default as MagicWandIcon } from '../assets/MagicWand.svg';
export { default as MailIcon } from '../assets/Mail.svg';
export { default as MicrophoneIcon } from '../assets/Microphone.svg';
export { default as MicrosoftOutlookIcon } from '../assets/MicrosoftOutlook.svg';
export { default as MoreAlternateIcon } from '../assets/MoreAlternate.svg';
export { default as MoreIcon } from '../assets/More.svg';
export { default as MeetingIcon } from '../assets/Meeting.svg';
export { default as NetworkIcon } from '../assets/Network.svg';
export { default as NewBadgeIcon } from '../assets/NewBadge.svg';
export { default as PaintBrushWideIcon } from '../assets/PaintBrushWide.svg';
export { default as PencilIcon } from '../assets/Pencil.svg';
export { default as PlaybackPauseIcon } from '../assets/PlaybackPause.svg';
export { default as PlaybackPlayIcon } from '../assets/PlaybackPlay.svg';
export { default as PlaybackStopIcon } from '../assets/PlaybackStop.svg';
export { default as PopOutIcon } from '../assets/PopOut.svg';
export { default as PrintIcon } from '../assets/Print.svg';
export { default as PuzzleIcon } from '../assets/Puzzle.svg';
export { default as QuestionMarkIcon } from '../assets/QuestionMark.svg';
export { default as ReorderIcon } from '../assets/Reorder.svg';
export { default as ReplyIcon } from '../assets/Reply.svg';
export { default as RulerIcon } from '../assets/Ruler.svg';
export { default as SailboatIcon } from '../assets/Sailboat.svg';
export { default as SearchIcon } from '../assets/Search.svg';
export { default as SendIcon } from '../assets/Send.svg';
export { default as ShareIcon } from '../assets/Share.svg';
export { default as ShuffleIcon } from '../assets/Shuffle.svg';
export { default as SignInIcon } from '../assets/SignIn.svg';
export { default as StarEmptyIcon } from '../assets/StarEmpty.svg';
export { default as StarIcon } from '../assets/Star.svg';
export { default as SuitcaseIcon } from '../assets/Suitcase.svg';
export { default as SyncIcon } from '../assets/Sync.svg';
export { default as TargetIcon } from '../assets/Target.svg';
export { default as TextSizeIcon } from '../assets/TextSize.svg';
export { default as UnderlineIcon } from '../assets/Underline.svg';
export { default as UndoIcon } from '../assets/Undo.svg';
export { default as WarningIcon } from '../assets/Warning.svg';

export { default as Man1Illustration } from '../illustrations/man1.svg?url';
export { default as Man2Illustration } from '../illustrations/man2.svg?url';
export { default as Man3Illustration } from '../illustrations/man3.svg?url';
export { default as Man4Illustration } from '../illustrations/man4.svg?url';
export { default as Man5Illustration } from '../illustrations/man5.svg?url';
export { default as Female1Illustration } from '../illustrations/female1.svg?url';
export { default as Female2Illustration } from '../illustrations/female2.svg?url';
export { default as Female3Illustration } from '../illustrations/female3.svg?url';
export { default as Female4Illustration } from '../illustrations/female4.svg?url';
export { default as Female5Illustration } from '../illustrations/female5.svg?url';
export { default as InsightsIllustration } from '../illustrations/Insights.svg?url';
export { default as ExpiredIllustration } from '../illustrations/expired.svg?url';

export * as flags from './flags';
